import axios, { getEnv } from './api';

const Eventoervice = {
  listar: async () => {
    try {
      const res = await axios.get(
        `${await getEnv('REACT_APP_URL_SERVICE')}/eventos`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  filtrar: async (paramss) => {
    try {
      const res = await axios.post(
        `${await getEnv('REACT_APP_URL_SERVICE')}/filtrar`,
        paramss
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  salvar: async (params) => {
    try {
      const res = await axios.post(
        `${await getEnv('REACT_APP_URL_SERVICE')}/eventos`,
        params
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  atualizar: async (params) => {
    try {
      const res = await axios.put(
        `${await getEnv('REACT_APP_URL_SERVICE')}/eventos`,
        params
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  deletar: async (id) => {
    try {
      const res = await axios.delete(
        `${await getEnv('REACT_APP_URL_SERVICE')}/eventos/${id}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
};

export default Eventoervice;
